<div
     [ngBusy]="{busy: busy, message: 'Loading application, please wait...', backdrop: false, delay: 1, minDuration:750}">
     <div class="align-middle-wrapper aut-bg-img-side cotainer-fiuid align-items-stretch" *ngIf="!appInitialized">
          <div class="appLoader row align-items-center w-100 align-items-stretch bg-white align-middle-wrapper">

               <div class="d-none d-lg-flex col-lg-12 aut-bg-img align-items-center d-flex justify-content-center">
                    <div class="logo"></div>
               </div>
          </div>
     </div>



     <app-header [user]="currentUser" *ngIf="appInitialized" [customization]="customization">
     </app-header>
     <div class="page-content" *ngIf="appInitialized">
          <simple-notifications></simple-notifications>
          <router-outlet></router-outlet>
          <div id="modal-container"> </div>
          <app-event-details-tray *ngIf="currentUser && currentUser != null"></app-event-details-tray>


          <footer class="app-footer p-2">
               <div class="push"></div>
               <div class="footer-content">
                    <a href="http://www.bowmanmilano.com">Bowman</a> &copy; {{currentYear}}. {{serverVersion}} -
                    {{customization != null ? customization.title : 'Algorilla Frontend - Bowman S.r.l.'}}
                    v.{{frontendVersion}}
               </div>
          </footer>
     </div>

     <!-- [ngClass]="{'enabled':debugMode}"-->